/**
 * Count-up animation for .numbers--layout-a when row scrolls into viewport.
 */
(function () {
	const DURATION = 1500; // ms
	const EASING = t => 1 - Math.pow(1 - t, 3); // ease-out cubic

	function parseCountValue(str) {
		if (!str || typeof str !== 'string') return { value: 0, suffix: '' };
		const trimmed = str.trim();
		const match = trimmed.match(/^([\d.,\s]+)\s*([^\d]*)$/);
		if (!match) return { value: 0, suffix: trimmed };

		let numStr = match[1].replace(/\s/g, '');
		const suffix = (match[2] || '').trim();

		// Handle k, m multipliers in suffix
		let multiplier = 1;
		const lowerSuffix = suffix.toLowerCase();
		if (lowerSuffix.startsWith('k')) multiplier = 1000;
		else if (lowerSuffix.startsWith('m')) multiplier = 1000000;

		// Parse number: German (1.234,56) vs US (1,234.56)
		// If dot followed by exactly 3 digits → thousands separator
		const parts = numStr.split(/[.,]/);
		let value;
		if (parts.length === 2 && /^\d{3}$/.test(parts[1]) && !numStr.includes(',')) {
			// e.g. "1.234" or "1.000" → thousands
			value = parseFloat(numStr.replace(/\./g, ''));
		} else {
			const normalized = numStr.replace(',', '.');
			value = parseFloat(normalized);
		}
		value = (isNaN(value) ? 0 : value) * multiplier;
		return { value, suffix };
	}

	function formatNumber(value, suffix, decimals) {
		const num = decimals >= 0 ? value.toFixed(decimals) : Math.round(value);
		const formatted = String(num).replace('.', ',');
		return suffix ? formatted + suffix : formatted;
	}

	function animateCountUp(el) {
		const raw = el.getAttribute('data-count');
		const { value: target, suffix } = parseCountValue(raw);
		if (target <= 0) return;

		const start = performance.now();
		const decimals = target % 1 !== 0 ? 2 : 0;

		function tick(now) {
			const elapsed = now - start;
			const progress = Math.min(elapsed / DURATION, 1);
			const eased = EASING(progress);
			const current = target * eased;
			el.textContent = formatNumber(current, suffix, decimals);

			if (progress < 1) {
				requestAnimationFrame(tick);
			} else {
				el.textContent = formatNumber(target, suffix, decimals);
				el.classList.add('count-up-done');
			}
		}

		requestAnimationFrame(tick);
	}

	function init() {
		const rows = document.querySelectorAll('.numbers--layout-a');
		if (!rows.length) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					const row = entry.target;
					row.querySelectorAll('.js-count-up:not(.count-up-done)').forEach(animateCountUp);
					observer.unobserve(row);
				});
			},
			{ threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
		);

		rows.forEach((row) => observer.observe(row));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
